import * as React from 'react'

import { ICommonLocation } from '../utils/location/types'

const useLocationHashScroll = (location: ICommonLocation) => {
  React.useEffect(
    () => {
      const elementId = location.hash.slice(1)
      const element = document.getElementById(elementId)

      if (element) {
        element.scrollIntoView()
      } else {
        window.scrollTo(0, 0)
      }
    },
    [location]
  )
}

export default useLocationHashScroll
